export const environment = {
  production: true,
  apiUrl: 'https://test.api.qonnecthub.nl/api',
  staticApiUrl: 'https://test.api.qonnecthub.nl/api',
  shopifyApiKey: ''
};
